import videoHelpers from '../helpers/video';

let videos = document.querySelectorAll('.js-video');

const ANIMATION_LENGTH: number = 400;

const videoElement = {
  /**
   * Initialize video elements
   * @return {void}
   */
  initialize() {
    videos = document.querySelectorAll('.js-video');
    const videosArr = Array.prototype.slice.call(videos);

    if (videosArr.length) {
      videosArr.forEach((vid: HTMLElement[]) => {
        this.checkEmbed(vid);
      });
    }
  },

  /**
   * Check the sources of a video element and create listeners
   * @param  {HTMLElement} vid - jQuery element of video elements
   * @return {void}
   */
  checkEmbed(vid: HTMLElement) {
    const source = vid.dataset.videoSrc;

    if (source.length) {
      const type: string = (source.indexOf('youtube') >= 0 || source.indexOf('youtu.be') >= 0)
        ? 'youtube' : 'vimeo';

      this.createListener(vid, source, type);
    }
  },

  /**
   * Create click listeners on video elements to create embeds on click
   * @param  {HTMLElement} el   - jQuery element of the video
   * @param  {string} type - Video type (e.g. youtube or vimeo)
   * @return {void}
   */
  createListener(el: HTMLElement, source: string, type: string) {
    let embed: string = '';

    // YouTube specific code
    if (type === 'youtube') {
      const id: string = videoHelpers.getYoutubeId(source);
      embed = videoHelpers.createYoutubeEmbed(id);

      this.addYoutubePoster(el, id);

    // Vimeo specific code
    } else if (type === 'vimeo') {
      const id: string = videoHelpers.getVimeoId(source);
      embed = videoHelpers.createVimeoEmbed(id);

      this.addVimeoPoster(el, id);
    }

    // Listen for clicks on the poster element
    el.querySelector('.js-video-poster').addEventListener('click', (e: any) => {
      e.preventDefault();

      el.insertAdjacentHTML('beforeend', embed);
      el.classList.add('is-loaded');

      setTimeout(() => {
        el.classList.add('is-playing');
      }, ANIMATION_LENGTH);
    });
  },

  addYoutubePoster(el: HTMLElement, id: string) {
    // Get the poster with ID
    const poster = videoHelpers.getYoutubePoster(id);

    // Add the video poster on the element
    this.addVideoPoster(el, poster);
  },

  addVimeoPoster(el: HTMLElement, id: string) {
    videoHelpers.getVimeoPoster(id, (src: string) => {
      this.addVideoPoster(el, src);
    });
  },

  addVideoPoster(el: HTMLElement, poster: string) {
    // Get the poster element
    const posterNode: HTMLElement = el.querySelector('.js-video-poster');

    // Add the poster as background-image
    posterNode.style.backgroundImage = `url(${poster})`;
  },
};

export default videoElement;
